import { InsuranceRecommendation } from '../../../../interfaces/Insurance';
import { InsuranceAppendix, InsuranceAppendixPremiumTerm, InsuranceAppendixRecommendation } from '../../../../interfaces/InsuranceAppendix';
import {
    InsurancePolicy,
    InsurancePolicyMainBranch,
    InsurancePolicyPlanTypes,
    InsurancePolicyStatuses,
} from '../../../../interfaces/InsurancePolicy';

const insuranceStartDate = new Date();
insuranceStartDate.setMonth(insuranceStartDate.getMonth() + 1);
insuranceStartDate.setDate(1);

export const initialInsurancePolicyState: InsurancePolicy = {
    _id: '',
    clientId: '',
    recommendation: InsuranceRecommendation.noChange,
    status: InsurancePolicyStatuses.Initial,
    policyNumber: '',
    company: '',
    branch: InsurancePolicyMainBranch.healthInsurance,
    planType: InsurancePolicyPlanTypes.individual,
    insuranceId: '',
    templates: {
        quastionnaires: [],
        generalTemplates: [],
    },
    insuranceStartDate,
    appendices: [],
    replacementPolicies: [],
};
export const initialInsuranceAppendixState: InsuranceAppendix = {
    _id: '',
    isNew: true,
    clientId: '',
    insuredPerson: { name: '', idNumber: '' },
    type: '',
    policyId: '', // change to policy response id
    policy: '', // change to policy response id
    recommendation: InsuranceAppendixRecommendation.noChange,
    insuredList: [],
    branch: '',
    premium: NaN,
    premiumDiscountData: {
        premiumBeforeDiscount: NaN,
        discountTerm: 'lifeTime',
        currentDiscountPercent: NaN,
        discountExplanation: '',
        premiumAfterDiscount: NaN,
    },
    premiumTerm: InsuranceAppendixPremiumTerm.monthly,
    insuranceStartDate: '',
    issueDate: '',
};
